import type { BarDatum, BarLayer } from '@nivo/bar'

/**
 * Shared Nivo bar chart layer that renders a total count label above each
 * stacked bar group. Used by VoEStackedBarChart and VoEAuditTrailActivityChart.
 */
export const TotalLabelLayer: BarLayer<BarDatum> = (props) => {
  const { bars } = props

  const totals = new Map<
    string,
    { total: number; x: number; width: number; minY: number }
  >()
  for (const bar of bars) {
    const idx = String(bar.data.indexValue)
    const existing = totals.get(idx)
    if (existing) {
      existing.total += (bar.data.value as number) ?? 0
      existing.minY = Math.min(existing.minY, bar.y)
    } else {
      totals.set(idx, {
        total: (bar.data.value as number) ?? 0,
        x: bar.x,
        width: bar.width,
        minY: bar.y,
      })
    }
  }

  return (
    <g>
      {Array.from(totals.entries()).map(([key, { total, x, width, minY }]) =>
        total > 0 ? (
          <text
            key={key}
            x={x + width / 2}
            y={minY - 8}
            textAnchor="middle"
            fontSize={11}
            fontWeight={600}
            fill="#374151"
          >
            {total}
          </text>
        ) : null
      )}
    </g>
  )
}
